"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipTrialParticipateInternalResponseSchema = exports.MembershipTrialAvailableInternalResponseSchema = exports.MembershipTrialParticipateInputSchema = exports.MembershipTrialInfoInputSchema = exports.MEMBERSHIP_TRIAL_PARTICIPATE_CODE = exports.MEMBERSHIP_TRIAL_STATUS = exports.PARTICIPATE_CODE = exports.AVAILABLE_FAIL_CODE = void 0;
var zod_1 = require("zod");
exports.AVAILABLE_FAIL_CODE = {
    /** 이미 프로모션에 참여 */
    ALREADY_PARTICIPATED: 'ALREADY_PARTICIPATED',
    /** 현재 골드클래스 등급 */
    ALREADY_GOLD_CLASS: 'ALREADY_GOLD_CLASS',
    /** 진행중인 프로모션 없음 */
    NO_PROMOTION_AVAILABLE: 'NO_PROMOTION_AVAILABLE',
};
exports.PARTICIPATE_CODE = __assign(__assign({}, exports.AVAILABLE_FAIL_CODE), { 
    /** 신청 성공 */
    SUCCESS: 'SUCCESS' });
exports.MEMBERSHIP_TRIAL_STATUS = __assign(__assign({}, exports.AVAILABLE_FAIL_CODE), { 
    /** 로그인 안됨 */
    NOT_LOGIN: 'NOT_LOGIN', 
    /** 참여 가능 */
    AVAILABLE: 'AVAILABLE', 
    /** FAILOVER */
    FAILOVER: 'FAILOVER' });
exports.MEMBERSHIP_TRIAL_PARTICIPATE_CODE = __assign(__assign({}, exports.PARTICIPATE_CODE), { 
    /** 로그인 안됨 */
    NOT_LOGIN: 'NOT_LOGIN', 
    /** 신청 실패 */
    FAILOVER: 'FAILOVER' });
exports.MembershipTrialInfoInputSchema = zod_1.z.object({
    requestAt: zod_1.z.string().optional(),
});
exports.MembershipTrialParticipateInputSchema = zod_1.z.object({
    requestAt: zod_1.z.string().optional(),
});
/** 골드클래스 체험 프로모션 API - 1. 참여가능 여부 조회 응답 정보 */
exports.MembershipTrialAvailableInternalResponseSchema = zod_1.z.object({
    available: zod_1.z.boolean(),
    failCode: zod_1.z
        .enum([
        exports.AVAILABLE_FAIL_CODE.ALREADY_GOLD_CLASS,
        exports.AVAILABLE_FAIL_CODE.ALREADY_PARTICIPATED,
        exports.AVAILABLE_FAIL_CODE.NO_PROMOTION_AVAILABLE,
    ])
        .nullable(),
});
/** 골드클래스 체험 프로모션 API - 2. 참여하기 */
exports.MembershipTrialParticipateInternalResponseSchema = zod_1.z.object({
    code: zod_1.z.enum([
        exports.PARTICIPATE_CODE.SUCCESS,
        exports.PARTICIPATE_CODE.ALREADY_GOLD_CLASS,
        exports.PARTICIPATE_CODE.ALREADY_PARTICIPATED,
        exports.PARTICIPATE_CODE.NO_PROMOTION_AVAILABLE,
    ]),
    message: zod_1.z.string().optional(),
});
